import { render, staticRenderFns } from "./GoodsCategoryForm.vue?vue&type=template&id=0d2d8f02&scoped=true"
import script from "./GoodsCategoryForm.vue?vue&type=script&lang=ts"
export * from "./GoodsCategoryForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodsCategoryForm.vue?vue&type=style&index=0&id=0d2d8f02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2d8f02",
  null
  
)

export default component.exports